import io from 'socket.io-client';

const socket = io(process.env.REACT_APP_SOCKET_URL);

function subscribeToRoom(id, cb) {
    socket.on(`data_${id}`, data => cb(null, data));
    socket.emit('subscribeToRoom', id);
}

function updateState(id, state) {
    socket.emit('updateState', id, state);
}

function reset(id) {
    socket.emit('reset', id);
}

export { subscribeToRoom, updateState, reset };



// WEBPACK FOOTER //
// ./src/api.js